module.exports = __webpack_public_path__ + "static/media/glosolan.8b06ef1f.png";